(function( document, window, JSONParse, keyName, mainClass, maxAge ){
	var dataLayer = window.dataLayer || [];
	var localStorage = window.localStorage;
	var pageviewAlreadySent = false;

	// Go go go
	ready( run );

	function run() {
		setConsent( get( keyName ), false, event );

		// Register dom events
		registerEvents();
	}

	function setConsent( consentState, persist, event ) {
		event.preventDefault();

		// Set data layer variable
		// If consent is true, trigger a consentPageview event immediately
		var dataLayerVariable = {};

		if ( consentState === true && !pageviewAlreadySent ) {
			dataLayerVariable.event = 'consentPageview';
			pageviewAlreadySent = true;
		}

		// Set consent variable
		dataLayerVariable[ keyName ] = !!consentState;
		dataLayer.push(dataLayerVariable);

		// Set the popup state
		setCookiePopupState( consentState );

		// Update inline status messages
		updateStatusMessages( consentState );

		if ( persist && consentState !== null ) {
			set( keyName, consentState );
		} else if ( consentState === null ) {
			remove( keyName );
		}
	}

	function setCookiePopupState( consentState ) {
		forEachElement( getElementsByClassName( mainClass ), function( el ) {
			// Reset display style
			el.style.display = null;

			// Add the correct class
			el.className = mainClass + ' is-' + consentStateToStatus( consentState );
		});
	}

	function get( key ) {
		if ( localStorage ) {
			var value = localStorage.getItem( key );
			return value !== null ? JSONParse( value ) : null;
		} else {
			var match = document.cookie.match(new RegExp('(^| )' + key + '=([^;]+)'));
			return match ? JSONParse( match[ 2 ] ) : null;
		}
	}

	function set( key, value ) {
		if ( localStorage ) {
			localStorage.setItem( key, value );
		} else {
			document.cookie = keyName + '=' + value + ';max-age=' + maxAge;
		}
	}

	function remove( key ) {
		if ( localStorage ) {
			localStorage.removeItem( key );
		} else {
			document.cookie = key + '=; Max-Age=-99999999;';
		}
	}

	function forEachElement( elements, fn ) {
		[].forEach.call( elements, fn );
	}

	function getElementsByClassName() {
		return document.getElementsByClassName.apply(document, arguments);
	}

	function ready( fn ) {
		if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading'){
			fn();
		} else {
			document.addEventListener('DOMContentLoaded', fn);
		}
	}

	function on( el, eventName, eventHandler ) {
		el.addEventListener(eventName, eventHandler);
	}

	function updateStatusMessages( consentState ) {
		forEachElement( getElementsByClassName( 'js-' + mainClass + '-status' ), function( el ) {
			el.innerText = consentStateToStatus( consentState );
		});
	}

	function registerEvents() {
		// Accept button click handler
		registerConsentClick( 'js-' + mainClass + '-accept', true, true);
		registerConsentClick( 'js-' + mainClass + '-deny', false, true );
		registerConsentClick( 'js-' + mainClass + '-undecided', null, true );
	}

	function registerConsentClick( className, consentState, persist ) {
		forEachElement( getElementsByClassName( className ), function( el ) {
			on( el, 'click', function() {
				setConsent( consentState, persist, event );
			});
		});
	}

	function consentStateToStatus( consentState ) {
		return consentState === null ? 'undecided' : consentState === true ? 'given' : 'denied';
	}
})( document, window, JSON.parse, 'cookieConsent', 'qd-cookie-popup', 31536000 );



// WEBPACK FOOTER //
// ./assets/_js/cookie-script-localstorage.js